import { useState } from "react";
import Tile from "./Tile";
import Slavs from "./kafelki/Slavs";
import Backdrop from "./Backdrop";
import Twotwotwo from "./kafelki/twotwotwo";
import Stalker2 from "./kafelki/Stalker2";
import Datafox from "./kafelki/Datafox";
import Debata from "./kafelki/Debata";
import Samo from "./kafelki/DebataAuto";
import Fem from "./kafelki/Fem";
import styled from "styled-components";

import datafox from "../img/datafox.jpg";
import stalker from "../img/stalker_mini.png";
import fem from "../img/fem_mini.jpg";
import year from "../img/2022_mini.png";

import debata from "../img/debata_mini.jpg";
import debata2 from "../img/debata2_mini.jpg";
//Style tutaj
const All = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`;

const Grid = styled.div`
  height: 100%;
  padding-bottom: 20vh;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: max(1fr, auto);

  grid-gap: 50px;
  @media (max-width: 450px) {
    grid-template-columns: 1fr;
  }
  @media (max-width: 950px) {
    grid-template-columns: 1fr 1fr;
  }
`;
const Kratka = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

function Tileset() {
  //logika tutaj
  const [content, wybierzContent] = useState("balls");
  const [backdrop, otwieranieBackdrop] = useState(false);
  function ciemno(kontent) {
    wybierzContent(kontent);

    otwieranieBackdrop(true);
  }
  function antyciemno() {
    otwieranieBackdrop(false);
  }

  return (
    <All>
      {backdrop && <Backdrop jasno={antyciemno} kontent={content} />}
      <Grid>
        <Kratka>
          <Tile
            nazwa="Prace na FrontEndMentor"
            obraz={fem}
            funkcja={ciemno}
            kontent={<Fem />}
          />
        </Kratka>
        <Kratka>
          <Tile
            nazwa="Intro Debaty szkolnej o sys. operacyjnych"
            obraz={debata}
            funkcja={ciemno}
            kontent={<Debata />}
          />
        </Kratka>
        <Kratka>
          <Tile
            nazwa="Intro Debaty szkolnej o samochodach elek."
            obraz={debata2}
            funkcja={ciemno}
            kontent={<Samo />}
          />
        </Kratka>
        <Kratka className="youtube">
          <Tile
            nazwa="2022"
            obraz={year}
            funkcja={ciemno}
            kontent={<Twotwotwo />}
          />
        </Kratka>

        <Kratka>
          <Tile
            kontent={<Slavs />}
            nazwa="Niepotrzebnie długi film o stalkerze"
            obraz="https://i.ytimg.com/vi/kDQnQq_zeps/hqdefault.jpg?sqp=-oaymwEjCNACELwBSFryq4qpAxUIARUAAAAAGAElAADIQj0AgKJDeAE=&rs=AOn4CLCFl33kaBGusu2jkqFyPtE5gWh8aA"
            funkcja={ciemno}
          />
        </Kratka>

        <Kratka>
          <Tile
            nazwa="DataFox"
            obraz={datafox}
            funkcja={ciemno}
            kontent={<Datafox />}
          />
        </Kratka>

        <Kratka>
          <Tile
            nazwa="Reklama S.T.A.L.K.E.R. 2 (nieoficjalna)"
            obraz={stalker}
            funkcja={ciemno}
            kontent={<Stalker2 />}
          />
        </Kratka>
      </Grid>
    </All>
  );
}

export default Tileset;
